import loadGMRScript from "./loadGMRScript";
import OauthKit from "./OauthKit";
import env from "../util/environment";

class AuthService {
  constructor() {
    this.store = null;
    this.user = null;
    /**
     *
     * @type {MinigamesApi} project Api
     */
    this.api = null;
  }
  getKit() {
    OauthKit.setStore(this.store);
    return OauthKit;
  }

  /**
   *
   * @param {object} config service config
   */
  setConfig(config) {
    this.config = config;
    this.store = config.store;
    this.api = config.api;
  }
  getConfig() {
    return this.config;
  }
  loadKit() {
    loadGMRScript(this.config.kit_config);
  }
  showSignup() {
    this.getKit().showSignup();
  }
  showSignin() {
    this.getKit().showLogin();
  }
  showProjectReg() {
    return this.getKit().showProjectRegister();
  }

  /**
   *
   * @param {object|null} user api user response
   */
  setUser(user) {
    if (user) {
      this.user = user;
    }
  }

  /**
   *
   * @return {object|null} prepared user
   */
  getUser() {
    return this.user;
  }
  isSocialLogin(login) {
    return !this.isMailLogin(login);
  }
  isMailLogin(login) {
    const mail_domains = ["bk.ru", "mail.ru", "mail.ua", "corp.mail.ru", "list.ru", "inbox.ru"];
    return mail_domains.indexOf(this.getLoginOrigin(login)) > -1;
  }
  getLoginOrigin(login) {
    const domain = login.split("@");
    return domain ? domain.toLowerCase() : false;
  }
  logout() {
    const logout_url = env.isMailRu() ? "/dynamic/auth/?plogout=1" : "/dynamic/auth/?a=plogout";

    fetch(logout_url, {
      method: "GET",
    }).then(() => {
      location.reload();
    });
  }
  downloadGame() {
    this.getKit().detectAndDownload();
  }
}
const service = new AuthService();
export default service;
